export const baseHostingURL = 'https://thinknum-embed-test.s3.amazonaws.com';